import * as React from "react";
import { Tag,Menu, Dropdown, Button,Icon} from 'antd';
import SmallTools from "widget/smallTools";
import AfterSale from "widget/tag/afterSale";
import Abnormal from "widget/tag/abnormal";
import Finance from "widget/tag/finance";
import Test from "widget/tag/test";
import Deviation from "widget/tag/deviation";
import Refund from "widget/tag/refund";
import Public from "widget/tag/public";
import _ from "lodash";
import { connect } from "react-redux";
interface Data {
  Tag: any;
  OrderNo:any;
  id:any;
  submitTag:any;
  getOrderDetails:any;
}



let tagColor = color => {
   let colorArr = {
       '1':'#e02222',
       '2':'#852b99',
       '3':'#ffb848',
       '4':'#e02222',
       '5':'#eaff00',
       '6':'#4b8df8',
       '7':'#555',
       '8':'#35aa47',
       '9':'#4b8df8',
       '10':'#555',
       '11':'#e02222',
       '12':'#a55b99',
       '13':'#555bee',
       '14':'#999',
       '15':'#e02222',
       '16':'#9933ff',
       '17':'#cc99ff',
       '18':'#e02222',
   };
   return colorArr[color];
}

class tag extends React.Component<Data> {
  state = {
    tag: [],
    tagarr: [],
    id:''
  };
  constructor(props: Data) {
    super(props);
  }


  getArrDifference(arr1, arr2) {
    console.log(arr1,arr2);
    if(arr2 == null){
      arr2 = [];
    }
    if(arr1 == null){
      arr1 = [];
    }
    return arr1.concat(arr2).filter(function(v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v);
    });
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {

    if(nextProps.id !=this.state.id ){
      this.setState({
        tag: nextProps.Tag,
        id: nextProps.id,
      });   
      return false;    
    }
    const keys = Object.keys(
      this.getArrDifference(nextProps.Tag, prevState.tag)
    ); 
     console.log(prevState.tag,nextProps.Tag);
    //if (prevState.tag.length != nextProps.Tag.length && nextProps.Tag.length != undefined)  {
     if(keys.length > 0){
        this.setState({
              tag: nextProps.Tag,
              id: nextProps.id,
        });
        if(nextProps.Tag != null){
          const tagarr = nextProps.Tag.map((item, key) => {
            return item['tagsid'];
            })
          this.setState({
                  tagarr: tagarr
          });
        }
        return false;
      }
    return true;
  }

  Close =(e) => {
    e.preventDefault();
  } 
  click = (value) => {
    const param: any = {
      id: this.props.id,
      type: 'tag_del',
      tagid:value,
    }; 
    this.props.submitTag({
      ...param,
      callback: (data) => {
          const params: any = {
            id: this.props.id
          }; 
          this.props.getOrderDetails({
            ...params,
            callback: () => {
              console.log(this.props);
            }
           });
      }
     }); 
  }
  tagList = () => {
    console.log(this.state.tag);
    if(!this.state.tag){
      return;
    }
    const listItems = this.state.tag.map((item, key) => {
      let classTag = 'tag'+item['tagsid'];
      if (item["is_del"] == 0) {
        return (
          <Tag key={key} className={classTag} color={tagColor(item['tagsid'])} >
            {item["name"]}
          </Tag>
        );
      } else {
        return (
          <Tag closable key={key} color={tagColor(item['tagsid'])} onClose={this.Close} onClick={this.click.bind(this,item['tagsid'])}>
            {item["name"]}
          </Tag>
        );
      }
    });
    console.log(listItems);
    return <React.Fragment>{listItems}</React.Fragment>;
  };

  render() {
    const menu = (
      <Menu >
        <Abnormal />
        <Public tag={this.state.tagarr} name="加急"  tagid="2"/>
        <Public tag={this.state.tagarr} name="占位"  tagid="3"/>
        <AfterSale orderNo={[this.props.OrderNo]} />
        <Refund tag={this.state.tagarr}  />
        <Test />
        <Public tag={this.state.tagarr} name="关闭"  tagid="7"/>
        <Finance />
        <Public tag={this.state.tagarr} name="打包"  tagid="9"/>
        <Deviation />
        <Public tag={this.state.tagarr} name="群"  tagid="16"/>
        <Public tag={this.state.tagarr} name="发"  tagid="18"/>
      </Menu>
    );

    return (
      <div className="tag">
        <label>订单标签：</label>
        <div className="taglist">
          <SmallTools
            content={this.tagList()}
            isOpenEnlarge={false}
            isOpenFieldDrawer={false}
          />
        </div>
        <div className="tagselect">
        <Dropdown overlay={menu}>
        <Button style={{ marginLeft: 8 }}>
          选择标签 <Icon type="down" />
        </Button>
      </Dropdown>          
        </div>
      </div>
    );
  }
}


const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    submitTag:dispatch.orderDetails.submitTag,
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
  };
};

export default connect(
  mapState ,
  mapDispatch
)(tag);

